import { Grid } from '@material-ui/core';
import { OverviewColumns } from './OverviewColumns';
import { OwnershipCard } from './OwnershipCard';
import { Topology } from './Topology';

/**
 * A component's Overview tab (specs/component-page.md): the three columns that
 * sort a reader's attention, then how it is connected and who owns it.
 */
export const ComponentOverview = () => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <OverviewColumns />
    </Grid>
    <Grid item xs={12} md={8}>
      <Topology />
    </Grid>
    <Grid item xs={12} md={4}>
      <OwnershipCard />
    </Grid>
  </Grid>
);
